import { render, staticRenderFns } from "./WarumSection.vue?vue&type=template&id=4ec93a34&"
import script from "./WarumSection.vue?vue&type=script&lang=js&"
export * from "./WarumSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports